import { EnvironmentProviders, inject, InjectionToken, makeEnvironmentProviders, Type } from '@angular/core';

export interface ILanguage {
  display: string;
  code: string;
}

export interface IQPointLocalizationInfo {
  defaultLocale: string;

  /**
   * Current application locale
   */
  getLocale(): string;

  /**
   * Locale for number formatting
   */
  getCultureInfoNumber(): string;

  /**
   * Locale for date / time formatting
   */
  getCultureInfoDatetime(): string;

  /**
   * Get localized languages for dropdown fields
   */
  getLanguages(lang?: string): Promise<ILanguage[]>;
}

export const DI_LOCALIZATION_INFO = new InjectionToken<IQPointLocalizationInfo>('QPointLocalizationProperties');

export function provideLocalizationInfo(useClass: Type<IQPointLocalizationInfo>): EnvironmentProviders {
  return makeEnvironmentProviders([{
    provide: DI_LOCALIZATION_INFO,
    useClass
  }])
}

export function injectLocalizationInfo(): IQPointLocalizationInfo {
  return inject(DI_LOCALIZATION_INFO);
}
